// src/features/itinerary/components/atoms/TimeBlock.jsx
import React from "react";

// icons
import {
  PlaneLanding,
  PlaneTakeoff,
  CirclePlay,
  CircleStop,
  Triangle,
  Square,
  DoorOpen,
  DoorClosed,
  DoorClosedLocked,
  Flag,
  FlagOff,
  KeySquare,
} from "lucide-react";
import { Icon } from "../../../../components/icons/Icon";
import { IconMap } from "../icons/IconMap";
import { tracks } from "../icons/Transportation";

export default function TimeBlock({ icon, time, tz }) {
  return (
    <div className="time-block">
      <div className="time-block-icon">
        {icon === "planeDepart" && <PlaneTakeoff />}
        {icon === "planeArrive" && <PlaneLanding />}
        {icon === "carDepart" && <Flag />}
        {icon === "carArrive" && <FlagOff />}
        {icon === "carRentalPickup" && <KeySquare />}
        {icon === "carRentalReturn" && <KeySquare />}
        {icon === "checkin" && <DoorOpen />}
        {icon === "checkout" && <DoorClosed />}
        {/* {icon === "start" && <CirclePlay />}
        {icon === "end" && <CircleStop />} */}
        {/* {icon === "start" && <span>-----</span>} */}
        {!icon && null}
      </div>
      {/* <div className="text time-block-time">{time || ""}</div> */}
      <div className="text time-block-time">
        {icon === "start"
          ? `\u25B6 ${time}`
          : icon === "end"
          ? `\u25FE ${time}`
          : time || ""}
      </div>
      <div className="text time-block-timezone">{tz || ""}</div>
      {/* <div className="time-block-icon">
        {icon === "end" && <span>-----</span>}
        {!icon && null}
      </div> */}
    </div>
  );
}
